// Brand configuration for whitelabeling
// Logo imports can be added when logo assets are available
// import brytebridgeLogo from "@/assets/logos/brytebridge/logo.svg";
// import foundationGroupLogo from "@/assets/logos/foundation-group/logo.svg";

import usfilingDarkLogo from "@/assets/logos/usfiling/logo-dark.svg";
import usfilingColorLogo from "@/assets/logos/usfiling/logo.svg";
import fileFloridaBlueLogo from "@/assets/logos/file-florida/FFCo-blue.svg";
import fileFloridaWhiteLogo from "@/assets/logos/file-florida/FFCo-white.svg";
import center501LightLogo from "@/assets/logos/501-center/logo.svg";
import center501DarkLogo from "@/assets/logos/501-center/logo-dark.svg";
import fileNorthCarolinaBlueLogo from "@/assets/logos/file-north-carolina/logo_blue.svg";
import fileNorthCarolinaWhiteLogo from "@/assets/logos/file-north-carolina/logo_white.svg";
import brytebridgeLogo from "@/assets/logos/brytebridge/BryteBridge.svg";
import brytebridgeSignInLogo from "@/assets/logos/brytebridge/BryteBridge_bridge_blue.svg";
import brytebridgeLogoBridgeDark from "@/assets/logos/brytebridge/BryteBridge.svg";
import brytebridgeLogoBridgeWhite from "@/assets/logos/brytebridge/BryteBridge_white.svg";
// import foundationGroupLogo from "@/assets/logos/foundation-group/logo.svg";

const baseColors = {
  white: "#fff",
  black: "#000",
};

// Brand color definitions
const usfsColors = {
  primaryColor: "#67bd4d", // Vibrant green for buttons and logo
  secondaryColor: "#1a4a8a", // Dark blue for header, footer
  backgroundColor: "#f0f5fa", // Light green-grey for main content background
  accentColor: "#0066cc", // Medium blue for links
};

const fileFloridaColors = {
  primaryColor: "#1a4a8a", // Dark blue for header, footer, buttons
  secondaryColor: "#5fa3fb", // Medium blue for accents and secondary actions
  backgroundColor: "#f0f5fa", // Light blue for main content background
  accentColor: "#0066cc", // Darker blue for links
};

const center501Colors = {
  primaryColor: "#2078b9", // Light blue for feather icon, links, and accents
  secondaryColor: "#0a344f", // Dark blue for header, footer, buttons
  backgroundColor: "#f0f5fa", // Very light blue for main content background
  accentColor: "#2078b9", // Light blue for links (same as primary)
};

const fileNorthCarolinaColors = {
  primaryColor: "#428bca", // Medium blue for buttons
  secondaryColor: "#008080", // Dark teal for header
  backgroundColor: "#eef5f8", // Very light blue for main content background
  accentColor: "#5fa3fb", // Medium blue for links
  headerBackgroundColor: "#217a7e", // Dark teal for header (matches design)
  footerBackgroundColor: "#4e5d70",
  textColor: "#008080",
  placeholderColor: "#008080",
  borderColor: "#008080",
};

const brytebridgeColors = {
  primaryColor: "#1a4a8a", // Dark blue for logo text, title, main text
  secondaryColor: "#5fa3fb", // Light blue for bridge icon and accents
  backgroundColor: "#f0f5fa", // Very light blue for main content background
  accentColor: "#0066cc", // Medium blue for links and buttons
};

const foundationGroupColors = {
  primaryColor: "#1a5490", // Professional blue
  secondaryColor: "#2c7fb8", // Lighter blue accent
  backgroundColor: "#f0f4f8",
};

// Logo maps

const signInLogoMap = {
  brytebridge: brytebridgeSignInLogo,
  "us-filing-services": usfilingDarkLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501DarkLogo,
  "file-north-carolina": fileNorthCarolinaBlueLogo,
};

// Header logos for light mode
const headerLogoMapLight = {
  brytebridge: brytebridgeLogoBridgeDark,
  "us-filing-services": usfilingDarkLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501LightLogo,
  "file-north-carolina": fileNorthCarolinaBlueLogo,
};

// Header logos for dark mode
const headerLogoMapDark = {
  brytebridge: brytebridgeLogoBridgeWhite,
  "us-filing-services": usfilingDarkLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501DarkLogo,
  "file-north-carolina": fileNorthCarolinaWhiteLogo,
};

// Header small logos for light mode
const headerLogoSmallMapLight = {
  brytebridge: brytebridgeLogoBridgeDark,
  "us-filing-services": usfilingDarkLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501LightLogo,
  "file-north-carolina": fileNorthCarolinaBlueLogo,
};

// Header small logos for dark mode
const headerLogoSmallMapDark = {
  brytebridge: brytebridgeLogoBridgeWhite,
  "us-filing-services": usfilingDarkLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501DarkLogo,
  "file-north-carolina": fileNorthCarolinaWhiteLogo,
};

const footerLogoMap = {
  brytebridge: brytebridgeLogo,
  "us-filing-services": usfilingColorLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501LightLogo,
  "file-north-carolina": fileNorthCarolinaWhiteLogo,
};

const checkoutLogoMap = {
  brytebridge: brytebridgeLogo,
  "us-filing-services": usfilingDarkLogo,
  "file-florida": fileFloridaBlueLogo,
  "501-center": center501DarkLogo,
  "file-north-carolina": fileNorthCarolinaBlueLogo,
};

const publicLogoMap = {
  brytebridge: brytebridgeLogo,
  "us-filing-services": usfilingColorLogo,
  "file-florida": fileFloridaWhiteLogo,
  "501-center": center501LightLogo,
  "file-north-carolina": fileNorthCarolinaWhiteLogo,
};

export const brandConfigs = {
  "us-filing-services": {
    name: "US Filing Services",
    domain: "filingservices.com",
    email: "email@filingservices.com",
    title: "Secure.FilingServices.com",
    borderRadius: "14px",
    buttonBorderRadius: "24px",
    primaryColor: usfsColors.primaryColor,
    secondaryColor: usfsColors.secondaryColor,
    accentColor: usfsColors.accentColor,
    white: baseColors.white,
    black: baseColors.black,
    formHeaderBackgroundColor: baseColors.white,
    formLayoutBackgroundColor: usfsColors.backgroundColor,
    footerPrimaryColor: usfsColors.secondaryColor,
    footerAccentColor: usfsColors.accentColor,
    footerDividerColor: usfsColors.backgroundColor,
    footerCopyrightTextColor: baseColors.white,
    fontFamily: "Inter",
    routePrefix: "/:jurisdiction/:product/",
    headerPrimaryColor: usfsColors.secondaryColor,
    headerNavigationPrimaryColor: baseColors.white,
    headerNavigationAccentColor: usfsColors.accentColor,
    headerNavigation: [
      {
        label: "Maintain a Business",
        routeTo: "https://www.filingservices.com",
      },
      {
        label: "Education",
        routeTo: "https://www.filingservices.com/faqs",
      },
      {
        label: "About Us",
        routeTo: "https://www.filingservices.com/about-us",
      },
    ],
    footerNavigation: [
      {
        label: "Terms of Service",
        routeTo: "https://www.filingservices.com/terms-of-service",
      },
      {
        label: "Privacy Policy",
        routeTo: "https://www.filingservices.com/privacy-policy",
      },
      { label: "About Us", routeTo: "https://www.filingservices.com/about" },
    ],
  },
  "file-florida": {
    name: "File Florida Co",
    domain: "fileflorida.com",
    email: "email@fileflorida.com",
    title: "Secure.FileFlorida.com",
    borderRadius: "6px",
    buttonBorderRadius: "6px",
    primaryColor: fileFloridaColors.primaryColor,
    secondaryColor: fileFloridaColors.secondaryColor,
    accentColor: fileFloridaColors.accentColor,
    white: baseColors.white,
    black: baseColors.black,
    formHeaderBackgroundColor: fileFloridaColors.primaryColor,
    formHeaderTextColor: baseColors.white,
    formHeaderDividerColor: fileFloridaColors.primaryColor,
    formLayoutBackgroundColor: fileFloridaColors.backgroundColor,
    footerPrimaryColor: fileFloridaColors.primaryColor,
    footerAccentColor: fileFloridaColors.accentColor,
    footerDividerColor: "#547184",
    footerCopyrightTextColor: baseColors.white,
    toggleButtonGroupTextColor: baseColors.white,
    fontFamily: "Lato",
    routePrefix: "/:product/",
    headerPrimaryColor: fileFloridaColors.primaryColor,
    headerNavigationPrimaryColor: baseColors.white,
    headerNavigationAccentColor: fileFloridaColors.accentColor,
    headerNavigation: [
      {
        label: "File Online",
        routeTo: "https://www.fileflorida.com",
      },
      {
        label: "About Us",
        routeTo: "https://www.fileflorida.com/about",
      },
      {
        label: "FAQs",
        routeTo: "https://www.fileflorida.com/faq",
      },
      {
        label: "Contact Us",
        routeTo: "https://www.fileflorida.com/contact",
      },
    ],
    footerNavigation: [
      {
        label: "Terms of Service",
        routeTo: "https://www.fileflorida.com/terms-of-service",
      },
      {
        label: "Privacy Policy",
        routeTo: "https://www.fileflorida.com/privacy-policy",
      },
      { label: "About Us", routeTo: "https://www.fileflorida.com/about" },
    ],
  },
  "501-center": {
    name: "501C3 Center",
    domain: "501c3center.com",
    email: "email@501c3center.com",
    title: "secure.501c3Center.com",
    borderRadius: "6px",
    buttonBorderRadius: "6px",
    primaryColor: center501Colors.primaryColor,
    secondaryColor: center501Colors.secondaryColor,
    accentColor: center501Colors.accentColor,
    white: baseColors.white,
    black: baseColors.black,
    formHeaderBackgroundColor: baseColors.white,
    formHeaderTextColor: baseColors.black,
    formHeaderDividerColor: center501Colors.primaryColor,
    formLayoutBackgroundColor: center501Colors.backgroundColor,
    footerPrimaryColor: center501Colors.secondaryColor,
    footerAccentColor: center501Colors.accentColor,
    footerDividerColor: baseColors.white,
    footerCopyrightTextColor: baseColors.white,
    toggleButtonGroupTextColor: baseColors.white,
    fontFamily: "Inter",
    routePrefix: "/:product/",
    headerPrimaryColor: center501Colors.secondaryColor,
    headerNavigationPrimaryColor: baseColors.white,
    headerNavigationAccentColor: center501Colors.accentColor,
    headerNavigation: [
      {
        label: "Maintain a Business",
        routeTo: "https://www.501c3center.com",
      },
      {
        label: "Education",
        routeTo: "https://www.501c3center.com/faqs",
      },
      {
        label: "About Us",
        routeTo: "https://www.501c3center.com/about-us",
      },
    ],
    footerNavigation: [
      {
        label: "Terms of Service",
        routeTo: "https://www.501c3center.com/terms-of-service",
      },
      {
        label: "Privacy Policy",
        routeTo: "https://www.501c3center.com/privacy-policy",
      },
      { label: "About Us", routeTo: "https://www.501c3center.com/about" },
    ],
  },
  "file-north-carolina": {
    name: "File North Carolina",
    domain: "filenorthcarolina.com",
    email: "email@filenorthcarolina.com",
    title: "Secure.FileNorthCarolina.com",
    borderRadius: "4px",
    buttonBorderRadius: "4px",
    primaryColor: fileNorthCarolinaColors.primaryColor,
    secondaryColor: fileNorthCarolinaColors.secondaryColor,
    accentColor: fileNorthCarolinaColors.accentColor,
    white: baseColors.white,
    black: baseColors.black,
    formHeaderBackgroundColor: baseColors.white,
    formHeaderTextColor: fileNorthCarolinaColors.textColor,
    formHeaderDividerColor: fileNorthCarolinaColors.primaryColor,
    formLayoutBackgroundColor: fileNorthCarolinaColors.backgroundColor,
    footerPrimaryColor: fileNorthCarolinaColors.footerBackgroundColor,
    footerAccentColor: fileNorthCarolinaColors.accentColor,
    footerDividerColor: fileNorthCarolinaColors.footerBackgroundColor,
    footerCopyrightTextColor: baseColors.white,
    toggleButtonGroupTextColor: baseColors.white,
    fontFamily: "Montserrat",
    routePrefix: "/:product/",
    headerPrimaryColor: fileNorthCarolinaColors.headerBackgroundColor,
    headerNavigationPrimaryColor: baseColors.white,
    headerNavigationAccentColor: fileNorthCarolinaColors.accentColor,
    headerNavigation: [
      {
        label: "FILE ANNUAL REPORT",
        routeTo: "https://www.filenorthcarolina.com",
      },
      {
        label: "FAQS",
        routeTo: "https://www.filenorthcarolina.com/faqs",
      },
      {
        label: "ABOUT US",
        routeTo: "https://www.filenorthcarolina.com/about-us",
      },
      {
        label: "CONTACT US",
        routeTo: "https://www.filenorthcarolina.com/contact-us",
      },
    ],
    footerNavigation: [
      {
        label: "TERMS OF SERVICE",
        routeTo: "https://www.filenorthcarolina.com/terms-of-service",
      },
      {
        label: "PRIVACY POLICY",
        routeTo: "https://www.filenorthcarolina.com/privacy-policy",
      },
      {
        label: "FAQS",
        routeTo: "https://www.filenorthcarolina.com/faqs",
      },
    ],
  },
  brytebridge: {
    name: "BryteBridge",
    domain: "brytebridge.com",
    email: "email@brytebridge.com",
    title: "BryteBridge",
    borderRadius: "8px",
    buttonBorderRadius: "8px",
    primaryColor: brytebridgeColors.primaryColor,
    secondaryColor: brytebridgeColors.secondaryColor,
    accentColor: brytebridgeColors.accentColor,
    white: baseColors.white,
    black: baseColors.black,
    formHeaderBackgroundColor: baseColors.white,
    formHeaderTextColor: baseColors.black,
    formHeaderDividerColor: brytebridgeColors.primaryColor,
    formLayoutBackgroundColor: brytebridgeColors.backgroundColor,
    footerPrimaryColor: "#4a5568",
    footerAccentColor: brytebridgeColors.accentColor,
    footerDividerColor: "#e2e8f0",
    footerCopyrightTextColor: baseColors.white,
    toggleButtonGroupTextColor: baseColors.white,
    fontFamily: "Inter",
    routePrefix: "/",
    headerPrimaryColor: baseColors.white, // White header background
    headerNavigationPrimaryColor: brytebridgeColors.primaryColor, // Dark blue text on white
    headerNavigationAccentColor: brytebridgeColors.accentColor,
    headerNavigation: [
      {
        label: "Dashboard",
        routeTo: "https://www.brytebridge.com",
      },
      {
        label: "About Us",
        routeTo: "https://www.brytebridge.com/about",
      },
      {
        label: "Contact",
        routeTo: "https://www.brytebridge.com/contact",
      },
    ],
    footerNavigation: [
      {
        label: "Terms of Service",
        routeTo: "https://www.brytebridge.com/terms-of-service",
      },
      {
        label: "Privacy Policy",
        routeTo: "https://www.brytebridge.com/privacy-policy",
      },
      {
        label: "About Us",
        routeTo: "https://www.brytebridge.com/about",
      },
    ],
  },
  "foundation-group": {
    name: "Foundation Group",
    domain: "foundationgroup.com",
    email: "email@foundationgroup.com",
    title: "Foundation Group",
    borderRadius: "6px",
    buttonBorderRadius: "6px",
    primaryColor: foundationGroupColors.primaryColor,
    secondaryColor: foundationGroupColors.secondaryColor,
    white: baseColors.white,
    black: baseColors.black,
    formHeaderBackgroundColor: baseColors.white,
    formHeaderTextColor: baseColors.black,
    formHeaderDividerColor: foundationGroupColors.primaryColor,
    formLayoutBackgroundColor: foundationGroupColors.backgroundColor,
    footerPrimaryColor: "#1e3a5f",
    footerAccentColor: foundationGroupColors.secondaryColor,
    footerDividerColor: "#cbd5e0",
    footerCopyrightTextColor: baseColors.white,
    toggleButtonGroupTextColor: baseColors.white,
    fontFamily: "Inter",
    routePrefix: "/",
    headerPrimaryColor: foundationGroupColors.primaryColor,
    headerNavigationPrimaryColor: baseColors.white,
    headerNavigationAccentColor: foundationGroupColors.secondaryColor,
    headerNavigation: [
      {
        label: "Home",
        routeTo: "https://www.foundationgroup.com",
      },
      {
        label: "Services",
        routeTo: "https://www.foundationgroup.com/services",
      },
      {
        label: "About Us",
        routeTo: "https://www.foundationgroup.com/about",
      },
      {
        label: "Contact",
        routeTo: "https://www.foundationgroup.com/contact",
      },
    ],
    footerNavigation: [
      {
        label: "Terms of Service",
        routeTo: "https://www.foundationgroup.com/terms-of-service",
      },
      {
        label: "Privacy Policy",
        routeTo: "https://www.foundationgroup.com/privacy-policy",
      },
      {
        label: "About Us",
        routeTo: "https://www.foundationgroup.com/about",
      },
    ],
  },
};

export const getCurrentBrand = () => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  return brandConfigs[brandName] || brandConfigs["brytebridge"];
};

export const getBrandPublicLogo = () => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  return publicLogoMap[brandName] || publicLogoMap["brytebridge"];
};

export const getBrandCheckoutLogo = () => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  return checkoutLogoMap[brandName] || checkoutLogoMap["brytebridge"];
};

export const getBrandHeaderLogo = (mode = "light") => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  const logoMap = mode === "dark" ? headerLogoMapDark : headerLogoMapLight;
  return logoMap[brandName] || logoMap["brytebridge"];
};

export const getBrandHeaderSmallLogo = (mode = "light") => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  const logoMap =
    mode === "dark" ? headerLogoSmallMapDark : headerLogoSmallMapLight;
  return logoMap[brandName] || logoMap["brytebridge"];
};

export const getBrandFooterLogo = () => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  return footerLogoMap[brandName] || footerLogoMap["brytebridge"];
};

export const getBrandSignInLogo = () => {
  const brandName = import.meta.env.VITE_BRAND || "brytebridge";
  return signInLogoMap[brandName] || signInLogoMap["brytebridge"];
};
